<!--
 * @Description: 事务处理 参与人员提交
 * @Author: PF
 * @Date: 2023-12-07 15:45:30
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:24:19
-->
<template>
  <div>
    <el-dialog class="w500 h500" :model-value="openShiWuChuLi" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">事务处理</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openShiWuChuLi', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="bz" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.bz" type="textarea" resize="none" :autosize='{minRows: 4, maxRows: 4}' />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传附件" prop="fjs" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-upload style="width:100%" class="upload-demo" drag multiple :show-file-list="false" :http-request="importClick" :limit="9" :on-exceed="exceed">
                <el-icon class="el-icon--upload">
                  <upload-filled />
                </el-icon>
                <div class="el-upload__text">
                  将文件拖到此处，或 <em>点击上传</em>
                </div>
              </el-upload>
              <el-progress v-if="isProgress" class="wp100" :percentage="percentage"></el-progress>
              <div class="fujian wp100" v-for="(item,index) in fjList" :key="item.showPath">
                <el-link :href="baseurl+item.showPath" target="_blank" type="primary">{{item.oldname}}</el-link>
                <el-link class="ml10" type="danger" @click="fuJianDel(index)"><span class="iconfont icon-shanchu"></span></el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openShiWuChuLi', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import axios from 'axios'
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow } from '@/api/common.js'

const props = defineProps({ openShiWuChuLi: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openShiWuChuLi', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})



// 资源文件上传
const baseurl = ref(process.env.VUE_APP_BASE_API)// 根路径
const fjList = ref([])
const exceed = () => {
  return warningPrompt('最多可以上传9个文件')
}
const isProgress = ref(false)
const percentage = ref(0)
const importClick = async (file) => {
  const fileSuffix = file.file.name.substring(
    file.file.name.lastIndexOf('.') + 1
  )
  // 检测违规格式 开始
  const whiteList = ['exe', 'com', 'bat', 'scr']
  const isSuffix = whiteList.includes(fileSuffix.toLowerCase())
  if (isSuffix) {
    return warningPrompt('禁止上传 ' + whiteList + ' 格式文件')
  }
  // // 检测违规格式 结束
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('fwjjmc', 'public')
  formData.append('wjjmc', 'zzsw') // 文件地址类别 /common/cyrcglCpgl/202210/18/1.jpg
  axios({
    url: process.env.VUE_APP_BASE_API + '/api/v2/sys/wenjian/upload',
    data: formData,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      accesscode: $cookies.get(process.env.VUE_APP_BASE_TOKEN)
    },
    // 上传进度
    onUploadProgress: (progressEvent) => {
      if (progressEvent.lengthComputable) {
        isProgress.value = true
        // 是否存在进度
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        percentage.value = percentCompleted
        if (percentCompleted === 100) {
          isProgress.value = true
        }
      }
    }
  }).then((res) => {
    const obj = {
      oldname: res.data.data.ymc,
      showPath: res.data.data.lj + res.data.data.mc,
      id: res.data.data.id
    }
    fjList.value.push(obj)
  })
}
// 删除附件
const fuJianDel = (ind) => {
  fjList.value.splice(ind, 1)
}
const row = ref()
watch(
  () => props.openShiWuChuLi,
  () => {
    if (props.openShiWuChuLi) {
      row.value = props.row
      ruleForm.value.id = props.row.dbgzid
      
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  ruleForm.value.fjs = fjList.value.map((item) => item.showPath)
  submitForm({
    url: '/api/v2/zuzhi/zuzhishiwu/canyurenyuantijiao',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      closeWindow('openShiWuChuLi', emits, true)
    }
  })
}
</script>
